const TestButton = () => {
  return <section className="py-16 relative">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-white p-12 rounded-lg shadow-lg pixel-border flex flex-col items-center justify-center">
          <h3 className="text-2xl font-degular text-forest mb-8">Test Button Example</h3>
          
          <button className="relative px-8 py-3 bg-gradient-to-b from-[#333333] to-[#000000] border border-[#555555] text-white font-degular font-medium shadow-[0_2px_4px_rgba(0,0,0,0.4)] overflow-hidden group rounded-xl">
            <span className="absolute inset-0 rounded-full bg-gradient-to-b from-[rgba(255,255,255,0.2)] to-transparent opacity-100 h-[50%]"></span>
            <span className="relative z-10">See pricing</span>
            
            {/* Button shine effect on hover */}
            <span className="absolute inset-0 rounded-full bg-gradient-to-r from-transparent via-[rgba(255,255,255,0.2)] to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700"></span>
          </button>
          
          <p className="mt-6 text-sm font-mono text-gray-600">
            Styled after the glossy black button from the provided image
          </p>
        </div>
      </div>
    </section>;
};
export default TestButton;